import gql from 'graphql-tag';

const CREATE_SALESFORCE_FOR_ORG = gql`
  mutation createSalesforceForOrg($where: OrgWhereUniqueInput!) {
    createSalesforceForOrg(where: $where) {
      id
      salesforceId
    }
  }
`;

export default CREATE_SALESFORCE_FOR_ORG;
